/*
 * Copyright (c) 2025, Wultra s.r.o. (www.wultra.com).
 *
 * All rights reserved. This source code can be used only for purposes specified
 * by the given license contract signed by the rightful deputy of Wultra s.r.o.
 * This source code can be used only by the owner of the license.
 *
 * Any disputes arising in respect of this agreement (license) shall be brought
 * before the Municipal Court of Prague.
 */

import { makeAutoObservable } from "mobx"

export class UserTotpStore {
    private totpObjectUrl: string | null = null

    constructor() {
        makeAutoObservable(this, {
            setTotpCode: true,
            clearTotpCode: true,
            totpImageUrl: true
        })
    }

    setTotpCode(blob: Blob): void {
        this.clearTotpCode()
        this.totpObjectUrl = URL.createObjectURL(blob)
    }

    /**
     * Clears the QR code and releases its object URL.
     */
    clearTotpCode(): void {
        if (this.totpObjectUrl) {
            URL.revokeObjectURL(this.totpObjectUrl)
            this.totpObjectUrl = null
        }
    }

    get totpImageUrl(): string | null {
        return this.totpObjectUrl
    }
}
